import { Building2, CheckCircle2, Rocket, WandSparkles } from "lucide-react";
import { Button, Card, Field } from "../components/ui";

export function TenantFactoryPage() {
  return (
    <div className="page-stack">
      <Card
        title="Fábrica de tenants"
        description="Provisionamento sem editar código."
        action={
          <Button>
            <WandSparkles size={16} /> Gerar plano
          </Button>
        }
      >
        <div className="form-grid">
          <Field label="Nome do cliente">
            <input placeholder="Empresa Exemplo" />
          </Field>
          <Field label="Slug">
            <input placeholder="empresa-exemplo" />
          </Field>
          <Field label="Produto">
            <select>
              <option>Planos e Benefícios</option>
              <option>Patrimônio e Recebíveis</option>
              <option>Vertical personalizada</option>
            </select>
          </Field>
          <Field label="Canal">
            <select>
              <option>Pilot</option>
              <option>Beta</option>
              <option>Stable</option>
            </select>
          </Field>
        </div>
        <div className="card-actions">
          <Button>
            <Rocket size={16} /> Provisionar em modo demo
          </Button>
        </div>
      </Card>
      <div className="two-column">
        <Card title="Etapas automáticas">
          <div className="task-list">
            {[
              "Organização e unidade",
              "Admin inicial",
              "Módulos e permissões",
              "Branding e domínios",
              "Catálogos e workflows",
              "Providers fake/sandbox",
              "Smoke test e relatório",
            ].map((label) => (
              <div className="task-item" key={label}>
                <CheckCircle2 size={17} />
                <div>
                  <strong>{label}</strong>
                  <span>Idempotente</span>
                </div>
              </div>
            ))}
          </div>
        </Card>
        <Card title="Produtos">
          <div className="task-list">
            <div className="task-item">
              <Building2 size={18} />
              <div>
                <strong>Cruzeiro Life</strong>
                <span>Benefícios e proteção</span>
              </div>
            </div>
            <div className="task-item">
              <Building2 size={18} />
              <div>
                <strong>Yatta Flow</strong>
                <span>Patrimônio e recebíveis</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
